import React from 'react';
import './style.css';
import RandD from './hybrid_technologies/images/RandD.jpg';

const RandD_innovation = () => {
    return (
        <>
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundImage: `url(${RandD})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', minHeight: '250px' }}>
                <h1 style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.8)' }}>Our R&D &amp; Innovation</h1>
            </div>
            <div className='blog'>
                <div className='blog-project1'>
                    <p>
                        At OctoNexus Power, research and development is at the heart of everything we do. Our R&D programme combines advanced numerical modelling, computational fluid dynamics, and biomimetic engineering to push the boundaries of what's possible in hydrogen and hybrid energy systems.
                    </p>
                    <p>
                        We collaborate with leading universities, research institutions, and industry partners to accelerate innovation. Our team actively publishes findings, contributes to open energy standards, and participates in EU and UK-funded research programmes focused on net-zero energy transition.
                    </p>
                    <p>
                        Current areas of active research include AI-optimised electrolysis efficiency, novel hydrogen storage materials, biomimetic flow management for hydraulic systems, and predictive maintenance algorithms for remote deployments.
                    </p>
                    <p>
                        Interested in a research collaboration or strategic partnership? <a href="/contactus" style={{ color: '#0fa19a' }}>Contact our R&D team</a> to explore opportunities.
                    </p>
                </div>
                <div className='blog-project2'>
                    <h2>Research Focus Areas</h2>
                    <ul>
                        <li>AI-optimised hydrogen production and storage</li>
                        <li>Biomimetic design for energy systems</li>
                        <li>Computational fluid dynamics and numerical modelling</li>
                        <li>Predictive maintenance and digital twins</li>
                        <li>Strategic university and industry partnerships</li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default RandD_innovation;
